import { motion } from "framer-motion";

export const Lantern = ({ className = "", ...rest }) => (
  <div aria-hidden className={`pointer-events-none relative ${className}`} {...rest}>
    {/* warm glow */}
    <motion.div
      className="absolute left-1/2 top-1/2 h-14 w-14 -translate-x-1/2 -translate-y-1/2 rounded-full bg-amber-400/45 blur-xl"
      animate={{ opacity: [0.5, 0.9, 0.65, 1, 0.55] }}
      transition={{ repeat: Infinity, duration: 2.4, ease: "easeInOut" }}
    />
    <svg viewBox="0 0 60 100" className="relative h-auto w-full drop-shadow-[0_6px_12px_rgba(0,0,0,0.4)]">
      {/* handle + cap */}
      <circle cx="30" cy="10" r="5" fill="none" stroke="#241C12" strokeWidth="3" />
      <path d="M14 27 L30 14 L46 27 Z" fill="#241C12" />
      <rect x="16" y="27" width="28" height="4" rx="2" fill="#241C12" />
      {/* body */}
      <rect x="18" y="31" width="24" height="43" rx="3" fill="#2A2118" />
      {/* warm glass */}
      <rect x="21" y="34" width="18" height="37" rx="2" fill="#F5C66B" />
      <rect x="21" y="34" width="18" height="37" rx="2" fill="url(#glassShade)" />
      <defs>
        <linearGradient id="glassShade" x1="21" y1="34" x2="39" y2="71">
          <stop stopColor="#FFF3C4" stopOpacity="0.9" />
          <stop offset="1" stopColor="#E88B1F" stopOpacity="0.4" />
        </linearGradient>
      </defs>
      {/* flame */}
      <motion.ellipse
        cx="30"
        cy="57"
        rx="3.2"
        ry="6"
        fill="#FFF8DC"
        style={{ transformBox: "fill-box", transformOrigin: "bottom center" }}
        animate={{ scaleY: [1, 1.18, 0.94, 1.12, 1], opacity: [0.85, 1, 0.9, 1, 0.85] }}
        transition={{ repeat: Infinity, duration: 1.6, ease: "easeInOut" }}
      />
      {/* frame bars */}
      <line x1="30" y1="34" x2="30" y2="71" stroke="#2A2118" strokeWidth="2" />
      <line x1="21" y1="52" x2="39" y2="52" stroke="#2A2118" strokeWidth="2" />
      {/* base */}
      <rect x="16" y="74" width="28" height="5" rx="2" fill="#241C12" />
      <rect x="24" y="79" width="12" height="4" rx="2" fill="#241C12" />
    </svg>
  </div>
);
